<template>
    <v-list-item class="px-0">
        <v-list-item-avatar class="mr-1 mr-md-3">
            <v-icon
                color="teal accent-4"
                v-text="'mdi-check-circle-outline'"
            />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title >Authenticated User</v-list-item-title>
          <v-list-item-subtitle v-text="value.user_id"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="removable" class="ml-1 ml-md-3 pt-4">
            <v-btn @click="removeAccount" icon>
                <v-icon color="red lighten-1">
                    mdi-minus-circle
                </v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object,
                default: () => ({
                    user_id: null,
                }),
            },
            removable: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>
